module.exports = __webpack_public_path__ + "static/media/call_green.aab49643.svg";